import React, { useState, useEffect } from "react";
import { Table, Button, Image } from "react-bootstrap";
//import { NavLink } from "react-router-dom";
import BasicPagination from "../../../../Pagination/Pagination";
import ViewEventDetailsOffline from "./../../superAdminUsers/insidePageComponent/FavoritesPageInsideComponent/ViewEventDetailsOffline";
import ViewEventDetailsOnline from "./../../superAdminUsers/insidePageComponent/FavoritesPageInsideComponent/ViewEventDetailsOnline";
import moment from "moment";
import { useHistory } from "react-router-dom";
import isEmpty from "../../../../../store/validation/is-Empty";

const UserFavoritesEvents = (props) => {
  const history = useHistory();
  const [page, setPage] = useState(1);
  const [showView, setShowView] = useState(false);
  const [showView2, setShowView2] = useState(false);
  const [data, setData] = useState();
  const handleCloseView = () => setShowView(false);
  const handleShowView = (data) => {
    setData(data);
    setShowView(true);
  };
  const handleCloseView2 = () => setShowView2(false);
  const handleShowView2 = () => setShowView2(true);
  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(10);
  const [sort, setSort] = useState("");

  const handleBatchChange = (pageNo) => {
    window.scrollTo(0, 0);
    var calcStart = pageNo * 10 - 10;
    setStart(calcStart);
    setEnd(pageNo * 10);
    setPage(pageNo);
  };
  useEffect(() => {
    setPage(1);
    setStart(0);
    setEnd(10);
  }, [props.search]);

  useEffect(() => {
    if (!isEmpty(props.sortValue)) {
      setSort(props.sortValue);
    }
  }, [props.sortValue]);

  let filterEvents = props.groupByData.filter((event) => {
    return (
      event && event.name && event.name.toLowerCase().includes(props.search)
    );
  });

  if (sort === "A-Z") {
    filterEvents = filterEvents.sort((a, b) => {
      if (a?.name?.toLowerCase() < b?.name?.toLowerCase()) return -1;
      if (a?.name?.toLowerCase() > b?.name?.toLowerCase()) return 1;
      return 0;
    });
  } else if (sort === "Z-A") {
    filterEvents = filterEvents.sort((a, b) => {
      if (a?.name?.toLowerCase() < b?.name?.toLowerCase()) return 1;
      if (a?.name?.toLowerCase() > b?.name?.toLowerCase()) return -1;
      return 0;
    });
  }

  const onClickViewSetData = (data) => (e) => {
    history.push({
      pathname: "/superadminuserfavorite/group/event",
      state: { data: data },
    });
  };
  return (
    <React.Fragment>
      <div className="col-12 p-0 user-table-reusable-superadmin table-responsive">
        <Table className="HideShowTable enMinWidth900">
          <thead>
            <tr className="super_admin_all_users_table_head">
              <th style={{ width: "15%" }}>Restaurants</th>
              <th style={{ width: "25%" }}>Event Name</th>
              <th style={{ width: "10%" }}>Views</th>
              <th style={{ width: "10%" }}>Used</th>
              <th style={{ width: "15%" }}>Coupon Code</th>
              <th style={{ width: "15%" }}>Start & End Date</th>
              <th style={{ width: "10%" }}>Action</th>
            </tr>
          </thead>
          {filterEvents.slice(start, end).map((event, index) => (
            <tbody key={index}>
              <tr className="enUserFavoritesTableBody">
                <td style={{ width: "15%" }}>
                  {/* <NavLink
                    to="/superadminuserfavorite/group/event"
                    className="d-flex flex-column align-items-start"
                  > */}
                  <Button
                    onClick={onClickViewSetData(event)}
                    className="d-flex flex-column align-items-start"
                    style={{ background: "none", border: "none" }}
                  >
                    <div className="enImage45 ">
                      <Image
                        //src={require("../../../../../assets/images/UserManagement/fhr7.png")}
                        src={
                          event &&
                          event.restaurant_id &&
                          event.restaurant_id.logo_url
                        }
                        alt="View"
                        title="View"
                        fluid
                      />
                    </div>
                    <div className="f11-500 text-center mt-1">
                      {event &&
                        event.restaurant_id &&
                        event.restaurant_id.restaurant_name}
                    </div>
                  </Button>
                </td>
                <td style={{ width: "25%" }}>
                  <div className="d-flex align-items-center">
                    <div className="text-center d-flex flex-column align-items-center">
                      <div className="enImage45">
                        <Image
                          //src={require("../../../../../assets/images/UserManagement/offer.png")}
                          src={event && event.photos[0]}
                          alt="View"
                          title="View"
                          fluid
                          className="'w-100 h-100"
                        />
                      </div>
                      <div className="enPendingLBL mt-2">Offline</div>
                    </div>
                    <div className="pl-3">
                      <div className="f14-500">{event && event.name}</div>
                    </div>
                  </div>
                </td>
                <td style={{ width: "10%" }}>
                  <div className="f16-500">{event && event.eventViews}</div>
                </td>
                <td style={{ width: "10%" }}>
                  <div className="f16-500">{event && event.eventUsed}</div>
                </td>
                <td style={{ width: "15%" }}>
                  <div className="f16-500">{event && event.coupon_code}</div>
                </td>
                <td style={{ width: "15%" }}>
                  <div className="f16-400">
                    {" "}
                    {moment(event && event.start_date).format("Do MMM  YY")} -
                  </div>
                  <div className="f16-400 text-red">
                    {moment(event && event.end_date).format("Do MMM  YY")}
                  </div>
                </td>
                <td style={{ width: "10%" }}>
                  <Button
                    variant="link"
                    className="enIconBtn"
                    onClick={() => handleShowView(event)}
                  >
                    <Image
                      src={require("../../../../../assets/images/UserManagement/eye.svg")}
                      alt="View"
                      title="View"
                      fluid
                    />
                  </Button>
                </td>
              </tr>
            </tbody>
          ))}
          {/* <tbody>
            <tr className="enUserFavoritesTableBody">
              <td style={{ width: "15%" }}>
              <NavLink
                  to="/superadminuserfavorite/group/event"
                  className="d-flex flex-column align-items-start"
                >
                  <div className="enImage45 ">
                    <Image
                      src={require("../../../../../assets/images/UserManagement/fhr7.png")}
                      alt="View"
                      title="View"
                      fluid
                    />
                  </div>
                  <div className="f11-500 text-center mt-1">McDonald</div>
                </NavLink>
              </td>
              <td style={{ width: "25%" }}>
                <div className="d-flex align-items-center">
                  <div className="text-center d-flex flex-column align-items-center">
                    <Image
                      src={require("../../../../../assets/images/UserManagement/offer.png")}
                      alt="View"
                      title="View"
                      fluid
                    />
                    <div className="enSuccessLBL mt-2">Online</div>
                  </div>
                  <div className="pl-3">
                    <div className="f14-500">Pune comedy festival</div>
                  </div>
                </div>
              </td>
              <td style={{ width: "10%" }}>
                <div className="f16-500">250</div>
              </td>
              <td style={{ width: "10%" }}>
                <div className="f16-500">120</div>
              </td>
              <td style={{ width: "15%" }}>
                <div className="f16-500">LS1245</div>
              </td>
              <td style={{ width: "15%" }}>
                <div className="f16-400">25th Feb 20 -</div>
                <div className="f16-400 text-red">25th Mar 20</div>
              </td>
              <td style={{ width: "10%" }}>
                <Button
                  variant="link"
                  className="enIconBtn"
                  onClick={handleShowView2}
                >
                  <Image
                    src={require("../../../../../assets/images/UserManagement/eye.svg")}
                    alt="View"
                    title="View"
                    fluid
                  />
                </Button>
              </td>
            </tr>
          </tbody> */}
        </Table>
      </div>
      {filterEvents.length !== 0 ? (
        <BasicPagination
          totalRecords={filterEvents.length}
          limit={10}
          batch={page}
          onBatchChange={(e) => handleBatchChange(e)}
        />
      ) : (
        <> </>
      )}
      <ViewEventDetailsOffline
        onClickCloseView={handleCloseView}
        onClickshowView={showView}
        event={data}
      />
      <ViewEventDetailsOnline
        onClickCloseView={handleCloseView2}
        onClickshowView={showView2}
      />
    </React.Fragment>
  );
};

export default UserFavoritesEvents;
